import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Wallet, CheckCircle } from 'lucide-react'

export default function FonteRecursoDialog({
  open,
  onOpenChange,
  title = 'Pronto para Pagamento',
  description = 'Informe a fonte de recurso e a previsão de pagamento',
  fonteRecurso,
  setFonteRecurso,
  previsaoPagamento,
  setPrevisaoPagamento,
  onSubmit,
  testIdPrefix = '',
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Wallet className="w-5 h-5 text-amber-600" />
            {title}
          </DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor={`${testIdPrefix}fonte_recurso`}>Fonte de Recurso</Label>
            <Input
              id={`${testIdPrefix}fonte_recurso`}
              value={fonteRecurso}
              onChange={(e) => setFonteRecurso(e.target.value)}
              placeholder="Ex: FMS, FUNDEB, Recurso Próprio, PAB"
              required
              autoFocus
              data-testid={`input-${testIdPrefix}fonte-recurso`}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${testIdPrefix}previsao_pagamento`}>Previsão de Pagamento</Label>
            <Input
              id={`${testIdPrefix}previsao_pagamento`}
              type="date"
              value={previsaoPagamento}
              onChange={(e) => setPrevisaoPagamento(e.target.value)}
              required
              data-testid={`input-${testIdPrefix}previsao-pagamento`}
            />
            <p className="text-xs text-slate-500">Após aprovação, o processo entrará na agenda de pagamentos</p>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button type="submit" className="bg-amber-600 hover:bg-amber-700" data-testid={`confirmar-${testIdPrefix}fonte-btn`}>
              <CheckCircle className="w-4 h-4 mr-2" />
              Confirmar
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
